import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesDataStatusHeaderOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-data-status-header-outline_svg__Layer_1"
    x={0}
    y={0}
    width={15}
    height={15}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>
      {
        ".spaces-data-status-header-outline_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#666}"
      }
    </style>
    <path
      id="spaces-data-status-header-outline_svg__Line"
      className="spaces-data-status-header-outline_svg__st0"
      d="M7 4h1v5H7z"
    />
    <path
      id="spaces-data-status-header-outline_svg__Dot_2_"
      className="spaces-data-status-header-outline_svg__st0"
      d="M7 10h1v1H7z"
    />
    <path
      id="spaces-data-status-header-outline_svg__Circle"
      d="M7.5 1C3.9 1 1 3.9 1 7.5S3.9 14 7.5 14 14 11.1 14 7.5 11.1 1 7.5 1zm0 12C4.5 13 2 10.5 2 7.5S4.5 2 7.5 2 13 4.5 13 7.5 10.5 13 7.5 13z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#666766",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesDataStatusHeaderOutline);
export default Memo;
